import React from 'react';
import { approachSteps } from '../mock';

const Approach = () => {
  return (
    <section id="approach" className="relative py-24 md:py-32">
      <div className="absolute inset-0 grid-bg opacity-60 pointer-events-none" />
      <div className="relative mx-auto max-w-6xl px-5">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 text-[12px] tracking-[0.2em] uppercase text-[#C2603A]">
            <span className="w-5 h-px bg-[#C2603A]/60" /> Our Approach <span className="w-5 h-px bg-[#C2603A]/60" />
          </div>
          <h2 className="serif-display text-4xl md:text-6xl mt-4 text-ink">
            From Idea to Impact in 4 Steps
          </h2>
        </div>

        <div className="relative mt-16 max-w-4xl mx-auto">
          {/* Vertical connecting line */}
          <div className="hidden md:block absolute top-0 bottom-0 left-1/2 w-px bg-gradient-to-b from-[#C2603A]/10 via-[#C2603A]/30 to-[#C2603A]/10" />

          <div className="flex flex-col gap-10 md:gap-16">
            {approachSteps.map((s, i) => {
              const isRight = i % 2 === 1;
              return (
                <div key={s.number} className="relative md:grid md:grid-cols-2 md:gap-10 items-start">
                  {/* Node */}
                  <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 top-8 w-4 h-4 rounded-full bg-white border-2 border-[#C2603A] items-center justify-center z-10">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#C2603A]" />
                  </div>

                  <div className={`${isRight ? 'md:col-start-2' : ''}`}>
                    <div className="rounded-2xl bg-white border border-ink-10 p-6 md:p-7 soft-card border-l-4 border-l-[#C2603A]">
                      <div className="text-[#C2603A] font-semibold tracking-wide text-sm">{s.number}</div>
                      <h3 className="serif-display text-2xl md:text-3xl mt-2 text-ink">{s.title}</h3>
                      <p className="mt-3 text-[15px] leading-relaxed text-muted">{s.description}</p>
                      <div className="mt-4 inline-block text-[11px] tracking-[0.12em] uppercase text-[#C2603A] bg-[#FCE7D6]/60 border border-[#C2603A]/20 rounded-full px-3 py-1">
                        {s.meta}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Approach;
